import * as React from "react";
import type { SVGProps } from "react";

const FacilityParking = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M8.125 6.25V13.75"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.125 6.25H10.7188C11.1912 6.25 11.6442 6.44754 11.9783 6.79917C12.3123 7.15081 12.5 7.62772 12.5 8.125C12.5 9.16053 11.7025 10 10.7188 10H8.125"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="2.5"
      y="2.5"
      width="15"
      height="15"
      rx="2"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityParking.displayName = "FacilityParking";

export default FacilityParking;
